/**
 * Small SVG star icon button for favoriting solutions.
 *
 * Filled = favorited (amber), outline = not (slate, hover amber).
 */
interface StarButtonProps {
  slug: string;
  favorited: boolean;
  onToggle(): void;
}

export function StarButton({ slug: _slug, favorited, onToggle }: StarButtonProps) {
  // _slug is accepted per the prop interface but the toggle callback
  // is already scoped to the correct slug by the parent.

  return (
    <button
      type="button"
      onClick={onToggle}
      title={favorited ? 'Remove from favorites' : 'Add to favorites'}
      className={`transition-colors p-1 ${
        favorited
          ? 'text-amber-400'
          : 'text-slate-500 hover:text-amber-300'
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-5 w-5"
        fill={favorited ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
        />
      </svg>
    </button>
  );
}
